// First, so it is recording console errors and failed API calls before
// any other module runs -- the screenshot popup's "Scan App" reads it.
import './utils/devMessages';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './store/store';
import  ThemeContext  from "./context/ThemeContext"; 
import { startPixelCursors } from './utils/pixelCursors';
import { AuthProvider } from './context/AuthContext';

// The pixel arrow and hand, in the theme's colours (css/theme/cursors.css).
startPixelCursors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store = {store}>
      <BrowserRouter basename='/'>
        <ThemeContext>      
          <AuthProvider>
          <App />          
        </AuthProvider>    
        </ThemeContext>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
